import NotificationItem from './notification-item';

export default NotificationItem;